import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import {
  InputGroup,
  FieldWrapper,
  Label,
  SubmitBtn,
  CombineInputGroup,
} from "../Styles/InputStyles";
import Loading from "../Loading";
import MenuItem from "@mui/material/MenuItem";
import Select from "react-select";
import Model from "../Model";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const AddSubAdminModel = ({
  SingleEntryLoading,
  postAddUser,
  setOpenUploadModel,
}) => {
  const [uploadFile, setUploadFile] = useState("");
  const [districtsList, setDistricts] = useState([]);
  const { t, i18n } = useTranslation();
  const InitialValues = {
   name:'',
  };

  const SubmitHandler = (values) => {
    // console.log(values);
    
    postAddUser(values);
  };

  const Roles = [
    { value: "1", label: "Registrar" },
    { value: "2", label: "Customers" },
    { value: "3", label: "Subadmins" },
    { value: "4", label: "Reports" },
    // { value: "Administrator", label: "Administrator" },
  ];

  return (
    <Model width={`w-11/12 max-w-lg `} setOpenModel={setOpenUploadModel}>
      <Title>Add Game</Title>

      {SingleEntryLoading && <Loading />}

      {!SingleEntryLoading && (
        <Formik initialValues={InitialValues} onSubmit={SubmitHandler}>
          <Form>
            <Wrapper>
              {/* <CombineInputGroup> */}
                <InputGroup>
                  <Label htmlFor="name" >Game Name</Label>
                  <FieldWrapper>
                    <Field name="name" id="name" autoComplete="off" required/>
                  </FieldWrapper>
                </InputGroup>
                {/* <InputGroup>
                  <Label htmlFor="lName">Last Name</Label>
                  <FieldWrapper>
                    <Field name="lName" id="lName" autoComplete="off" required/>
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup>
              <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="email">Email</Label>
                <FieldWrapper>
                  <Field
                    type="text"
                    name="email"
                    id="email"
                    autoComplete="off"
                    className="truncate"
                    required
                  />
                </FieldWrapper>
              </InputGroup>

              <InputGroup>
                <Label htmlFor="mobile">Phone Number</Label>
                <FieldWrapper>
                  <Field
                    type="number"
                    onInput={(e) => {
                      if (e.target.value.length > e.target.maxLength)
                      e.target.value = e.target.value.slice(0,e.target.maxLength);
                          }}
                     maxlength = {10}
                    name="mobile"
                    id="mobile"
                    autoComplete="off"
                    className="truncate"
                    
                  />
                </FieldWrapper>
              </InputGroup>
              </CombineInputGroup>
              <InputGroup>
                  <Label htmlFor="password">Password</Label>
                  <FieldWrapper>
                    <Field
                      type="password"
                      name="password"
                      id="password"
                      autoComplete="off"
                      className="truncate"
                      required
                    />
                  </FieldWrapper>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="type">Roles/Permission for View & Manage</Label>
                  <FieldWrapper $select={true}>
                    <Field required name="type" id="type" autoComplete="off"  >
                      {(props) => (
                        <Select
                        className="w-full h-full"
                        isMulti
                        required
                        options={Roles}
                        classNamePrefix="select"
                        onChange={(val) => {
                          //console.log(val.value)
                          props.form.setFieldValue("roles", val)
                        }
                        }
                        //value={props.form.values.type}
                      />
                      )}
                    </Field>
                    </FieldWrapper>
                </InputGroup> */}
      
              {/* <CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="region">{t("c_region")}</Label>
                  <FieldWrapper $select={true}>
                    <Field
                      required
                      name="region"
                      id="region"
                      autoComplete="off"
                    >
                      {(props) => (
                        <Select
                          className="w-full h-full"
                          options={RegionList}
                          onChange={(val) => {
                            SetDynamicDistricts(val.value);
                            props.form.setFieldValue(
                              "region",
                              val.value
                            )
                          }
                          }
                        />
                      )}
                    </Field>
                  </FieldWrapper>
                </InputGroup>
                <InputGroup>
                  <Label htmlFor="district">{t("C_District")}</Label>
                  <FieldWrapper $select={true}>
                    <Field
                      required
                      name="district"
                      id="district"
                      autoComplete="off"
                    >
                      {(props) => (
                        <Select
                          className="w-full h-full"
                          options={DistrictList}
                          onChange={(val) =>
                            props.form.setFieldValue(
                              "district",
                              val.value
                            )
                          }
                        />
                      )}
                    </Field>
                  </FieldWrapper>
                </InputGroup>
              </CombineInputGroup> */}

            </Wrapper>
            <BtnWrapper>
              <SubmitBtn type="submit">Add</SubmitBtn>
            </BtnWrapper>
          </Form>
        </Formik>
      )}
    </Model>
  );
};

const Wrapper = tw.div`
grid  gap-6 my-6 px-1`;
const SampleFile = tw.a` w-full pt-3 text-blue-500 underline text-sm text-center`;

const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const BtnWrapper = tw.div`flex justify-center items-center mt-8`;

export default AddSubAdminModel;
